export const environment = {
    production: false,
    StarAPIURL: 'https://cfcustarapi-development.azurewebsites.net/',
    appID: 'e9df5b83-d608-400b-8e03-cac74d768e08',
    scopes: ['https://cfcustarapi-development.azurewebsites.net/user_impersonation'],
    redirectUri: 'https://star-dev.connectfirstcreditunion.net/home'
};
